import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem, Menu, Link } from '@sm/wds-react';
import { t } from '@sm/intl';
import NavBarCopy from '../../../copy/NavBarCopy';
import getMyTeamMenuItems from '../../../../../helpers/TeamMenuHelpers';
import MyTeamTrigger from './MyTeamTrigger';

import './nav-teammenu.scss';

export const MyTeamMenu = ({ user, session }) => {
  const title = t(NavBarCopy.MY_TEAM);
  const menuItems = getMyTeamMenuItems({ user, session });

  return (
    <Menu
      placement="bottom-left"
      noRules
      dense
      menuTrigger={MyTeamTrigger(title)}
      key={title}
    >
      {menuItems.map(item => {
        return (
          <MenuItem key={`${item.name}-teamMenu`}>
            <Link
              href={item.path}
              color="dark"
              className="sm-nav-teammenu__menu-link"
            >
              {item.name}
            </Link>
          </MenuItem>
        );
      })}
    </Menu>
  );
};

MyTeamMenu.propTypes = {
  user: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  session: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

MyTeamMenu.defaultProps = {
  session: undefined,
};

export default MyTeamMenu;
